import { render, staticRenderFns } from "./ImageSelectorDialog.vue?vue&type=template&id=2b3ad4ea&scoped=true"
import script from "./ImageSelectorDialog.vue?vue&type=script&lang=js"
export * from "./ImageSelectorDialog.vue?vue&type=script&lang=js"
import style0 from "./ImageSelectorDialog.vue?vue&type=style&index=0&id=2b3ad4ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3ad4ea",
  null
  
)

export default component.exports